<div class="trigger" (click)="toggleMenu()">
  <i class="fa-solid fa-filter"></i>
</div>

@if (showMenu) {
  <div class="garage-wrapper add-shadow">
    <div class="garage-title" translate>Garage Filter</div>
    <div class="garage-filter">
      <div class="search-wrapper">
        <input #searchInput autocomplete="new-password" type="text" [formControl]="query" (keyup)="updateFilter()" placeholder="{{ 'Find garage' | translate }}" />
        @if (!query.value) {
          <div class="suffix-wrapper">
            <mat-icon>search</mat-icon>
          </div>
        } @else {
          <div class="suffix-wrapper close-button" (click)="$event.stopPropagation(); resetFilter(); searchInput.focus()">
            <i class="fa-solid fa-circle-xmark"></i>
          </div>
        }
      </div>
    </div>
    <div class="traffic-areas">
      @for (trafficArea of trafficAreas; track trackByIndex($index, trafficArea)) {
        @if (trafficArea.visible) {
          <app-toggle-view [expanded]="expanded" [ngClass]="{'highlight': trafficArea.someSelected}"
            >
            <ng-container title>
              <mat-checkbox class="traffic-area-checkbox" [checked]="trafficArea.allSelected"
                [indeterminate]="trafficArea.someSelected && !trafficArea.allSelected"
                (click)="$event.stopPropagation(); toggleTrafficArea($event, trafficArea)">
              </mat-checkbox>
              <span>{{trafficArea.name}}</span>
            </ng-container>
            <ng-container info>
              {{trafficArea.subTitle}}
            </ng-container>
            <ng-template>
              <div class="filter-group">
                @for (garage of trafficArea.garages; track garage) {
                  @if (trafficArea.visibleGarages[garage.code] === true) {
                    <mat-checkbox
                      [checked]="toggleableOptions[garage.code]"
                      (change)="toggleGarageIsSelected($event, garage.code)">
                      {{ garage.description }}
                    </mat-checkbox>
                  }
                }
              </div>
            </ng-template>
          </app-toggle-view>
        }
      }
    </div>
  </div>
}